module.exports = "<app-home></app-home>\n<app-leistungen></app-leistungen>\n<app-project></app-project>\n<app-about-us></app-about-us>\n"